import { render, staticRenderFns } from "./addMultiple.vue?vue&type=template&id=bbc87198&"
import script from "./addMultiple.vue?vue&type=script&lang=js&"
export * from "./addMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports